import React, { useEffect, useState } from 'react';
import { Route, Routes, useLocation, Navigate } from 'react-router-dom';
import 'animate.css/animate.min.css';
import { WOW } from 'wowjs';

import Preloader from '../components/Preloader';
import ScrollToTop from '../components/ScrollToTop';
import LoadTop from '../components/ScrollToTop/LoadTop';
import BloodDonationPopup from "../components/BloodDonation/BloodDonationPopup";

// Custom Contact and Appointment
import ContactForm from '../components/Contact/ContactForm';
import AppointmentForm from '../components/Appointment/Appointment';
import Contactz from '../pages/home-5/ContactArea';

// Blog and Misc Pages
import BlogDetailsMain from '../pages/blog/BlogDetailsMain';
import Complain from '../pages/Complain/index';
import BloodDonation from '../pages/bloodDonation/index';

// Appointment Portal
import LoginPageApp from '../components/GetAppointments/LoginPage';
import DashboardApp from '../components/GetAppointments/Dashboard';

// Patient/Doctor Portal
import PatientDashboard from '../components/PatientLogin/PatientDashboard';
import LoginPage from '../components/PatientLogin/LoginPage';
import DoctorLogin from '../components/PatientLogin/DoctorLogin';
import DoctorDashboard from '../components/PatientLogin/DoctorDashboard';
import DoctorSignup from '../components/PatientLogin/DoctorSignup';
import DoctorsPortfolio from '../components/PatientLogin/DoctorsPortfolio';
import DocPortfolio from '../components/PatientLogin/portfolio';
import DoctorLayout from '../components/PatientLogin/DoctorLayout';

// Pages
import {
  About, Appointment, Blog, BlogDetails, BlogSidebar, Cart,
  Checkout, Compare, Contact, Error, Faq, Home, HomeFive, HomeFiveOnePage,
  HomeFour, HomeFourOnePage, HomeOnePage, HomeSix, HomeSixOnePage,
  HomeThree, HomeThreeOnePage, HomeTwo, HomeTwoOnePage,
  Login, Portfolio, PortfolioDetails, Price, Register,
  Service, ServiceDetails, ShopColumnFour, ShopColumnThree,
  ShopDetails, ShopSidebar, Team, TeamDetails, Wishlist, Career
} from '../pages';

import PrivacyMain from '../pages/privacy/privacyMain';
import PageViews from '../pages/page-views/PageViews';
import TesterPage from '../components/Tester/testerModal';
import MedicalMain from '../pages/MedicalEducation/index';
import DoctorList from '../components/newSlot/DoctorList';
import SlotPage from '../components/newSlot/SlotPage';
import DoctorProfilePage from '../components/PatientLogin/DoctorProfilePage';
import HouseJob from '../pages/HouseJob/index';
import Fellowship from '../pages/Fellowship/index';
import SkillMain from '../components/SkillLab/index';
import AdminLogin from '../components/Admin/AdminLogin';
import AdminDashboard from '../components/Admin/AdminDashboard';
import EventsPage from '../components/Admin/EventsPage';
import Certificates from '../pages/Certificates';
import CertificatesMain from '../pages/Certificates/CertificatesMain';
import DutyForm from '../components/HospitalRoaster/DutyForm';
import DutyList from '../components/HospitalRoaster/DutyList';
import RoasterLogin from '../components/HospitalRoaster/RoasterLogin';
import ExportEnglishPDF from '../components/HospitalRoaster/ExportEnglishPDF';
import ExportUrduPDF from '../components/HospitalRoaster/ExportUrduPDF';
import DutyLists from '../components/HospitalRoaster/DutyLists';
import FilterExportPage from '../components/HospitalRoaster/FilterExportPage';
import VVIPRoaster from '../components/HospitalRoaster/VVIPRoaster';
import ArchivePage from '../pages/blog/ArchivePage';
import RegisterCompany from '../pages/RegisterCompany/index'
import GalleryPage from '../pages/blog/GalleryPage';
import CswCombinedPDF from '../components/HospitalRoaster/CswCombinedPDF';
import GeneralWardRoasterCombinedPDF from '../components/HospitalRoaster/GeneralWardRoasterCombinedPDF';
import RoasterVideoPlayer from '../components/HospitalRoaster/RoasterVideoPlayer';
import RibbonCutScreen from '../components/RibbonCutScreen';
import RibbonCutting from '../components/RibbonCutting';
import VideoPage from '../components/video/index';
import InfectionMain from '../pages/InfectionPrevention/index';
import LibraryInaguration from '../components/LibraryInaguration';
import DoctorSelfAttendance from '../components/HospitalRoaster/DoctorSelfAttendance';
import DoctorAttendanceView from '../components/HospitalRoaster/DoctorAttendanceView';
import LoginStaffPortal from '../components/HospitalRoaster/LoginStaffPortal';
import HospitalDepartments from '../components/HospitalRoaster/HospitalDepartments';







// Hook to track page views
const usePageViews = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    fetch('https://ricgop.online/api/page-views.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ path }),
    })
      .then(res => res.json())
      .then(data => console.log('Page view updated:', data))
      .catch(err => console.error('Error updating page view:', err));
  }, [location.pathname]);
};


function App() {
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const [userId, setUserId] = useState(null);
  const [doctorId, setDoctorId] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  usePageViews();

  useEffect(() => {
    setTimeout(() => setIsLoading(false), 500);
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      new WOW({ live: false, animateClass: 'animate__animated' }).init();
    }
  }, [location]);

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://embed.tawk.to/683168a5fa521d190891c033/1is0g1i20';
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // const hiddenPopupRoutes = [
  //   '/privacy-policy', '/page-views', '/doctor/login', '/roaster/login', '/entry/roaster/vvip', '/entry/roaster/ams', 'archive', 
  //   '/doctor/signup', '/patient/dashboard', '/patient/booking', '/patient/login', '/skill-lab', '/admin/login', '/admin/dashboard', '/entry/roaster/dutylist', '/entry/roaster/dutyform',
  //   '/doctor/dashboard', '/getAppointment/login', '/getAppointment/dashboard', '/doctor/profile', '/medical' , '/doctor/face' , '/medical/house-job' , '/medical/fellowship-program' , '/' , '/team', '/about-us', '/appointment', '/gallery', '/edportal'
  // ];

  return (
    <div className="App">
      {isLoading && <Preloader />}
      <ScrollToTop />
      <LoadTop />
{/* 
      {!hiddenPopupRoutes.includes(location.pathname) && <BloodDonationPopup />} */}

      <BloodDonationPopup />

      <Routes>
        {/* Just Testing / Temporary */}
        <Route path="/doctor/list" element={<DoctorList />}  />
        <Route path="/slots/:id" element={<SlotPage />} />
        <Route path="/doctor/face" element={<DoctorProfilePage />} />
        <Route path="/medical/house-job" element={<HouseJob />} />
        <Route path="/medical/fellowship-program" element={<Fellowship />} />
        <Route path="/skill-lab" element={<SkillMain />} />
        <Route path="/media" element={<VideoPage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />}/>
        <Route path="/admin/events" element={<EventsPage />}/>
        <Route path="/certificates" element={<Certificates />}/>
        <Route path="/entry/roaster/dutyform" element={<DutyForm />} />
        <Route path="/entry/roaster/dutylist" element={<DutyList />} />
        <Route path="roaster/login" element={<RoasterLogin />}/>
        <Route path="roaster/eng" element={<ExportEnglishPDF />}/>
        <Route path="roaster/urdu" element={<ExportUrduPDF />}/>
        <Route path="/entry/roaster/ams" element={<FilterExportPage />}/>
        <Route path="/entry/roaster/vvip" element={<VVIPRoaster />}/>
        <Route path="/entry/roaster/csw" element={<CswCombinedPDF />}/>
        <Route path="/entry/roaster/gw" element={<GeneralWardRoasterCombinedPDF />}/>

        <Route path="/loadRoasterVideo" element={<RoasterVideoPlayer />}/>

        <Route path="/archive" element={<ArchivePage />}/>
        <Route path="/gallery" element={<GalleryPage />}/>

            <Route path="/patientDashboard" element={<HospitalDepartments />}/>


        <Route path="/new/roaster/dutylists" element={<DutyLists />}/>

        <Route path='/ribbon/play' element={<RibbonCutScreen />}  />


        <Route path='/ribbon' element={<RibbonCutting />}  />


        <Route path='/ribbon/library' element={<LibraryInaguration />}  />


        {/* Home Routes */}
        <Route path="/" element={<HomeFive />} />
        <Route path="/home-5" element={<Home />} />
        <Route path="/home-5-one-page" element={<HomeFiveOnePage />} />
        <Route path="/home-one-page" element={<HomeOnePage />} />
        <Route path="/home-2" element={<HomeTwo />} />
        <Route path="/home-2-one-page" element={<HomeTwoOnePage />} />
        <Route path="/home-3" element={<HomeThree />} />
        <Route path="/home-3-one-page" element={<HomeThreeOnePage />} />
        <Route path="/home-4" element={<HomeFour />} />
        <Route path="/home-4-one-page" element={<HomeFourOnePage />} />
        <Route path="/home-6" element={<HomeSix />} />
        <Route path="/home-6-one-page" element={<HomeSixOnePage />} />

        {/* Pages */}
        <Route path="/about-us" element={<About />} />
        <Route path="/service" element={<Service />} />
        <Route path="/service-details" element={<ServiceDetails />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/portfolio-details" element={<PortfolioDetails />} />
        <Route path="/team" element={<Team />} />
        <Route path="/team-details" element={<TeamDetails />} />
        <Route path="/tenders" element={<Faq />} />
        <Route path="/careers" element={<Career/>}/>
        <Route path="/price" element={<Price />} />
        <Route path="/edportal" element={<Appointment />} />
        <Route path="/shop-column-3" element={<ShopColumnThree />} />
        <Route path="/shop-column-4" element={<ShopColumnFour />} />
        <Route path="/shop-sidebar" element={<ShopSidebar />} />
        <Route path="/shop/:productId" element={<ShopDetails />} />
        <Route path="/wishlist" element={<Wishlist />} />
        <Route path="/compare" element={<Compare />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/login" element={<Login setUserId={setUserId} />} />
        <Route path="/register" element={<Register />} />
        <Route path="/registercompany" element={<RegisterCompany/>}/>

        {/* Blog */}
        <Route path="/event" element={<Blog />} />
        <Route path="/blog-sidebar" element={<BlogSidebar />} />
        <Route path="/blog-details/:id" element={<BlogDetails />} />
        <Route path="/blog/:id" element={<BlogDetailsMain />} />

        {/* Custom Contact/Appointment */}
        <Route path="/contact" element={<Contact />} />
        <Route path="/custom-contact" element={<ContactForm />} />
        <Route path="/custom-appointment" element={<AppointmentForm />} />
        <Route path="/custom-contactz" element={<Contactz />} />

        {/* Other Pages */}
        <Route path="/complain" element={<Complain />} />
        <Route path="/donateblood" element={<BloodDonation />} />
        <Route path="/privacy-policy" element={<PrivacyMain />} />
        <Route path="/page-views" element={<PageViews />} />
        <Route path="/patient/booking" element={<TesterPage />} />
        <Route path="/medical" element={<MedicalMain />} />
        <Route path="/infection-prevention" element={<InfectionMain/>} />



        {/* Attendance */}
        <Route path="/attendance-login" element={<LoginStaffPortal/>} />
        <Route path="/mark-attendance" element={<DoctorSelfAttendance/>} />
        <Route path="/view-attendance" element={<DoctorAttendanceView/>} />
        

        {/* Patient Dashboard */}
        <Route path="/patient/login" element={<LoginPage setUserId={setUserId} />} />
        <Route path="/patient/dashboard" element={<PatientDashboard userId={userId} />} />

        {/* Doctor Portal */}
        <Route path="/doctor/login" element={
          <DoctorLogin onLogin={(doctor) => {
            setDoctorId(doctor.id);
            localStorage.setItem("doctor", JSON.stringify(doctor));
            window.location.href = "/doctor/dashboard";
          }} />
        } />
        <Route path="/doctor/dashboard" element={<DoctorDashboard doctorId={doctorId} />} />
        <Route path="/doctor/signup" element={<DoctorSignup />} />
        <Route path="/doctor/portfolio" element={<DoctorsPortfolio />} />
        <Route path="/doctor/profile" element={<DocPortfolio />} />
        <Route path="/doctor/*" element={<DoctorLayout />} />

       <Route
          path="/getAppointment/login"
          element={<LoginPageApp onLogin={() => setIsLoggedIn(true)} />}
        />
        <Route
          path="/getAppointment/dashboard"
          element={isLoggedIn ? <DashboardApp /> : <Navigate to="/getAppointment/login" />}
        />

        {/* Error Page */}
        <Route path="*" element={<Error />} />
      </Routes>
  
    </div>
  );
}

export default App;
